import { ActivityType } from "@/modules/lead-page/dtos/index-v2";
import { useActivityContext } from "@/modules/lead-page/new/hooks/activity-context.hook";
import useActivityTimeline from "@/modules/lead-page/new/hooks/activity-timline.hook";

const useFilterMenuItems = () => {
  const {
    filters: { setIncludeChildLead, setType, includeChildLead, type } = {},
  } = useActivityContext();

  const { hasChild } = useActivityTimeline();

  const isSingleSelected = (t: ActivityType) =>
    type && type.length === 1 && type[0] === t;

  const isAllSelected = () => {
    const all = [
      ActivityType.Comment,
      ActivityType.StatusUpdate,
      ActivityType.AssignmentUpdate,
      ActivityType.Rating,
      ActivityType.ZoomCall,
      ActivityType.WhatsappConversation,
    ];
    return (
      type && type.length === all.length && all.every((t) => type.includes(t))
    );
  };

  // Helper function to get the current selected logs filter text
  const getSelectedLogsFilterText = () => {
    if (isAllSelected()) return "All updates";
    if (isSingleSelected(ActivityType.Comment)) return "Comments";
    if (isSingleSelected(ActivityType.StatusUpdate)) return "Status updates";
    if (isSingleSelected(ActivityType.AssignmentUpdate)) return "Assignments";
    if (isSingleSelected(ActivityType.InterestUpdate))
      return "Interest Updates";
    if (isSingleSelected(ActivityType.Rating)) return "Ratings";
    if (isSingleSelected(ActivityType.ZoomCall)) return "Zoom Calls";
    if (isSingleSelected(ActivityType.WhatsappConversation)) return "WhatsApp";

    // Multiple selected but not all
    const selectedCount = type?.length ?? 0;
    return `${selectedCount} selected`;
  };

  // Helper function to get the current selected updates filter text
  const getSelectedUpdatesFilterText = () => {
    if (includeChildLead) return "Include child updates";
    return "Parent updates";
  };

  const logsFilters = [
    {
      label: "All",
      action: () =>
        setType?.([
          ActivityType.Comment,
          ActivityType.StatusUpdate,
          ActivityType.AssignmentUpdate,
          ActivityType.Rating,
          ActivityType.ZoomCall,
          ActivityType.WhatsappConversation,
        ]),
      checked: isAllSelected(),
    },
    {
      label: "Comment",
      action: () => setType?.([ActivityType.Comment]),
      checked: isSingleSelected(ActivityType.Comment),
    },
    {
      label: "Status updates",
      action: () => setType?.([ActivityType.StatusUpdate]),
      checked: isSingleSelected(ActivityType.StatusUpdate),
    },
    {
      label: "Assignments",
      action: () => setType?.([ActivityType.AssignmentUpdate]),
      checked: isSingleSelected(ActivityType.AssignmentUpdate),
    },
    {
      label: "Interest updates",
      action: () => setType?.([ActivityType.InterestUpdate]),
      checked: isSingleSelected(ActivityType.InterestUpdate),
    },
    {
      label: "Ratings",
      action: () => setType?.([ActivityType.Rating]),
      checked: isSingleSelected(ActivityType.Rating),
    },
    // {
    //   label: "Zoom Calls",
    //   action: () => setType?.([ActivityType.ZoomCall]),
    //   checked: isSingleSelected(ActivityType.ZoomCall),
    // },
    // {
    //   label: "WhatsApp",
    //   action: () => setType?.([ActivityType.WhatsappConversation]),
    //   checked: isSingleSelected(ActivityType.WhatsappConversation),
    // },
  ];

  const updatesFilters = hasChild
    ? [
        {
          label: "Include child updates",
          action: () => setIncludeChildLead?.((prev: boolean) => !prev),
          checked: includeChildLead,
        },
      ]
    : [];

  const filters = [
    {
      buttonText: getSelectedLogsFilterText(),
      menuItems: logsFilters,
      anchorOrigin: {
        vertical: "bottom" as const,
        horizontal: "right" as const,
      },
      transformOrigin: {
        vertical: "top" as const,
        horizontal: "right" as const,
      },
    },
    ...(hasChild
      ? [
          {
            buttonText: getSelectedUpdatesFilterText(),
            menuItems: updatesFilters,
            anchorOrigin: {
              vertical: "bottom" as const,
              horizontal: "left" as const,
            },
            transformOrigin: {
              vertical: "top" as const,
              horizontal: "left" as const,
            },
          },
        ]
      : []),
  ];

  return {
    filters,
    logsFilters,
    updatesFilters,
    getSelectedLogsFilterText,
    getSelectedUpdatesFilterText,
  };
};

export default useFilterMenuItems;
